<script module lang="ts">
  import type { StoryRowProps } from '../../../components';
  import type { Collection } from '@agapi/mlc-core';

  export interface StoryRowStoryblokProps {
    blok: {
      aria_label: string;
      collections: Collection[];
    }
  }
</script>

<script lang="ts">
  import { storyblokEditable } from "@storyblok/svelte";
  import { StoryRow } from '../../../components';

  const { blok }: StoryRowStoryblokProps = $props();
  const storyRowProps: StoryRowProps = {
    collections: blok.collections,
    ariaLabel: blok.aria_label,
    use: [[storyblokEditable, blok]],
    css: {},
  };
</script>

<StoryRow {...storyRowProps} />
